import React from "react";

const INPUT_CLASS = "h-6 min-w-0 w-full rounded-[4px] border border-slate-300 bg-white px-2 py-0 text-sm text-slate-700 outline-hidden focus:border-accent focus-visible:ring-2 focus-visible:ring-accent/30 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-400";

export default function DataManagerBusinessCopyPeriodFields({ period, defaultPeriod, disabled, onChange }) {
  return (
    <fieldset disabled={disabled} className="grid gap-2 rounded-[4px] border border-slate-200 p-3">
      <legend className="px-1 text-sm font-semibold text-slate-900">Période des commandes et des historiques liés</legend>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <label className="grid gap-1 text-sm text-slate-700">
          Du
          <input type="date" required value={period.start_date || ""} onChange={(event) => onChange({ ...period, start_date: event.target.value })} className={INPUT_CLASS} />
        </label>
        <label className="grid gap-1 text-sm text-slate-700">
          Au (facultatif)
          <input type="date" min={period.start_date || undefined} value={period.end_date || ""} onChange={(event) => onChange({ ...period, end_date: event.target.value || null })} className={INPUT_CLASS} />
        </label>
      </div>
      <p className="text-xs leading-5 text-slate-600">Les changements de date et leurs dépendances sont repris automatiquement. Le reste de l’historique local est conservé. Sans date de fin, toutes les dates à venir sont incluses. Les référentiels sont actualisés au complet.</p>
      <button type="button" onClick={() => onChange({ ...defaultPeriod })} className="w-fit rounded-[4px] border border-slate-300 bg-white px-2 py-1 text-xs font-semibold text-slate-700 hover:border-slate-400 hover:bg-slate-50 hover:text-slate-900 focus-visible:ring-2 focus-visible:ring-accent/30 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-400 disabled:opacity-100 disabled:shadow-none">
        14 derniers jours et à venir
      </button>
    </fieldset>
  );
}
